/**
 * Default validation limits shown in the UI (UX hints only).
 * Backend enforces the same values from root `.env` — keep in sync when changing limits.
 */
export const VALIDATION_LIMITS = {
  maxZipFileCount: 5,
  maxZipSizeMb: 21,
  techDocMaxSourceLines: 2000,
  techDocMaxGenerationsPerUser: 5,
  brdMaxGenerationsPerUser: 5,
};

export const PRODUCT_NAMES = {
  TECH_DOC: 'Intelligent Documentation Suite',
  BRD: 'BRD for Oracle Forms',
};
